import './config';

export { default as upload } from './upload';
 